var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn",attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }